export default __webpack_public_path__ + "static/media/dark-green-spring.376fbdda.png";